'use client'

import { usePathname } from "next/navigation"
import { navigateUrl } from "@/utils/client-request"
import { formatImageURL } from "@/utils/util"

const LG_SPAN: Record<number, string> = { 3: 'lg:col-span-3 lg:aspect-3/4', 4: 'lg:col-span-4 lg:aspect-1/1', 6: 'lg:col-span-6 lg:aspect-3/2', 12: 'lg:col-span-12 lg:aspect-3/1' }

export default function Categories({ categories, title = 'Барааны төрөл', limit = 8 }: { categories: any[], title?: string, limit?: number }) {
  const pathname = usePathname()
  const items = (categories || []).filter((c: any) => c?.thumbnail).slice(0, limit)
  if (items.length === 0) return null

  const lastRow = items.length % 4
  const lastRowStart = items.length - lastRow

  return (
    <section className="w-full px-4 lg:px-6 py-12 lg:py-16">
      <h2 className="mb-6 lg:mb-8 text-2xl sm:text-4xl tracking-tight text-foreground">{title}</h2>
      <ul className="grid grid-cols-2 lg:grid-cols-12 gap-1">
        {items.map((category: any, index: number) => {
          const lgSpan = lastRow && index >= lastRowStart ? 12 / lastRow : 3
          const mobileWide = items.length % 2 === 1 && index === items.length - 1
          return (
            <li key={category.id} className={`relative overflow-hidden bg-muted ${mobileWide ? 'col-span-2 aspect-3/2' : 'aspect-3/4'} ${LG_SPAN[lgSpan]}`}>
              <a href={navigateUrl(`/product?category=${category.slug || category.id}`, pathname)} className="group absolute inset-0 grid place-items-center focus-visible:outline-1 focus-visible:-outline-offset-4 focus-visible:outline-white">
                <img src={formatImageURL(category.thumbnail)} alt="" loading="lazy" decoding="async" className="absolute inset-0 size-full object-cover" />
                <span aria-hidden className="absolute inset-0 bg-black/10 transition-colors duration-300 group-hover:bg-black/25 motion-reduce:transition-none" />
                <span className="relative px-4 text-center text-sm sm:text-[15px] tracking-wide text-white pb-0.5 bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat bg-position-[0_100%] bg-size-[0%_1px] group-hover:bg-size-[100%_1px] transition-[background-size] duration-500 ease-out motion-reduce:transition-none">{category.name}</span>
              </a>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
